<template>
    <fab
    :position="position"
    :bg-color="bgColor"
    :enable-rotation="false"
    :main-tooltip=tooltipMessage
    >
    </fab>
</template>

<script>
import fab from 'vue-fab'
export default {
    props: ["tooltipMessage"],
    components: {fab},
    data(){
        return{
            bgColor: '#00a265',
            position: 'bottom-right',
        }
    }
}
</script>
